import { render } from "./ContactPage.vue?vue&type=template&id=9350ccd2"
const script = {}

import "./ContactPage.vue?vue&type=style&index=0&id=9350ccd2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__